import React from "react";
import { months } from "../../../../../../Utils/months";
import { RowNames } from "../../../Utils/TableComponents";
import { DatosEditablesSKIM, TotalRowNames } from "../Data/SKIMData";
import SKIMMonth from "./SKIMMonth";


export default function SKIMTable() {
    const editableRowNames = Object.values(DatosEditablesSKIM).map(item => item.rowName);

    const rowNames = [...editableRowNames, ...TotalRowNames];

    return (
        <div className="report__table-container">
            <h6>SKIM</h6>
            <div className="report__month-tables">
                <RowNames rowNames={rowNames} totalRows={[4, 6]} />
                {months.map((month, index) => {
                    return (<SKIMMonth key={index} month={month} monthIndex={index} />)
                })}
            </div>
        </div>
    );
}
